<template>
  <Dialog :visible="showModal" :modal="true" :closable="false" :showHeader="false" :breakpoints="{
    '1360px': '50vw',
    '1024px': '60vw',
    '960px': '90vw',
    '640px': '91vw',
  }" :style="{ width: '30vw' }" class="verification-modal">
    <div class="body">
      <div class="w-75 m-auto">
        <div class="mb-3 mt-4 text-dark text-end">
          إرسال الرمز عن طريق البريد الإلكتروني
        </div>
        <div class="form-label-group mb-4 ">
          <span class="p-float-label text-end fs-6">
            <InputText id="email" type="email" class="w-100 text-end" v-model="state.email" />
            <label class="w-100 px-4" for="email">البريد الإلكتروني</label>
            <div class="verified-icon" v-if="state.is_verified">
              <img :src="`${staticUrl}/static/images/verified.png`" alt="verified_img" />
            </div>
            <div class="verification" v-else>
              <button class="btn btn-lg btn-primary btn-block verify-btn" :disabled="isDisabled"
                @click.stop="toggleEmailVerificationModal()" type="button">تحقق
              </button>
            </div>
          </span>
        </div>


      </div>
      <div v-if="state.showEmailOTPForm">
        <div v-if="parseInt(state.counter, 10) >= 0">

          <form class="mb-3 d-flex flex-wrap align-items-center justify-content-center">
            <input type="number" v-model="state.num1" class="digit" :min="0" :max="9" ref="num1"
              @input="$refs.num2.focus()" @focus="state.num1 = null" autofocus />
            <input type="number" v-model="state.num2" class="digit" :min="0" :max="9" ref="num2"
              @input="$refs.num3.focus()" @keyup.delete="!state.num2 ? $refs.num1.focus() : ''"
              @focus="state.num2 = null" />
            <input type="number" v-model="state.num3" class="digit" :min="0" :max="9" ref="num3"
              @input="$refs.num4.focus()" @keyup.delete="!state.num3 ? $refs.num2.focus() : ''"
              @focus="state.num3 = null" />
            <input type="number" v-model="state.num4" class="digit" :min="0" :max="9" ref="num4"
              @input="$refs.num5.focus()" @keyup.delete="!state.num4 ? $refs.num3.focus() : ''"
              @focus="state.num4 = null" />
            <input type="number" v-model="state.num5" class="digit" :min="0" :max="9" ref="num5"
              @input="$refs.num6.focus()" @keyup.delete="!state.num5 ? $refs.num4.focus() : ''"
              @focus="state.num5 = null" />
            <input type="number" v-model="state.num6" class="digit" :min="0" :max="9" ref="num6"
              @input="$refs.num6.blur()" @focus="state.num6 = null"
              @keyup.delete="!state.num6 ? $refs.num5.focus() : ''" />
          </form>

          <!-- Send again and Counter -->
          <div class=" border-bottom  d-flex justify-content-center">
            <div class="counter mx-4">{{ formattedCounter }}</div>
            <div class="pb-4 cursor-pointer text-center text-primary fs-6 text-decoration-underline" @click="resendOTP"
              :class="{ 'opacity-50 disabled': !isUserAllowedToResend }">
              إرسال رمز التحقق مرة أخرى؟
            </div>
          </div>
        </div>
        <div v-else class="text-center color-primary">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
      </div>


      <div class="d-flex align-items-center justify-content-around mt-3">
        <div class="w-50 px-3" data-cy="verify">
          <Button class="p-button-rounded px-5 w-100" :class="{ 'button-loading': state.loading }" @click="submitOtp()"
            :disabled="!isOTPFilled || state.loading" :label="state.loading && counter !== 0 ? '' : 'يحفظ'"
            :icon="state.loading && counter !== 0 ? 'pi pi-spin pi-spinner' : ''" />
        </div>
      </div>
    </div>
  </Dialog>

</template>

<script setup>
import OTPService from "@/services/otp.service";
import { defineProps, defineEmits, reactive, inject, computed } from 'vue';
import { required, email } from "@vuelidate/validators";
import { OTP_TYPE } from "@/services/otp.service";
import { useVuelidate } from '@vuelidate/core';
import { useToast } from "primevue/usetoast";
import { ToastSeverity } from "primevue/api";
const props = defineProps(['showModal', 'mobile_number', 'requestType']);
const emit  = defineEmits([ "submit", 'setVerifiedEmail']);
const state = reactive({
  is_verified: false,
  email: "",
  showEmailOTPForm: false,
  otpType: OTP_TYPE,
  num1: null,
  num2: null,
  num3: null,
  num4: null,
  num5: null,
  num6: null,
  counterInterval: null,
  counter: null,
  loading: false,
});
const toast = useToast();
const staticUrl = inject("staticUrl");
const rules = {
  email: {
    required: required,
    email: email,
  },
};
const v$ = useVuelidate(rules, state);
const toggleEmailVerificationModal = () => {
  resendOTP();
  state.showEmailOTPForm = true;
};
const submitOtp = () => {
  OTPService.verifyOTP({
    otp: otp.value,
    request_type: props.requestType,
    mobile_number: props.mobile_number,
    email: state.email,
    model_id: '0',
  }).then(({data}) => {
    toast.add({
      severity: ToastSeverity.SUCCESS,
      detail: "تم التحقق بنجاح",
      life: 3000,
    });
    emit('setVerifiedEmail', state.email)
  })
    .catch(({ response }) => {
      console.error(response);
     
    }); // toast.add({
      //   severity: ToastSeverity.ERROR,
      //   detail: response.data.result,
      //   life: 3000,
      // });
};

const isUserAllowedToResend = computed(() => {
  return state.counter === 0;
});

const resetData = () => {
  state.num1 = null;
  state.num2 = null;
  state.num3 = null;
  state.num4 = null;
  state.num5 = null;
  state.num6 = null;
  state.numberOfAttemptsPerMinute = 3;
  state.counter = null;
  clearInterval(state.counterInterval);
}
const startCounter = () => {
  state.targetTime = Date.now() + state.counter * 1000;
  state.counterInterval = setInterval(() => {
    const remainingTime = Math.max(0, state.targetTime - Date.now());
    state.counter = Math.floor(remainingTime / 1000);
    if (state.counter === 0) {
      clearInterval(state.counterInterval);
    }
  }, 100);
}
const resendOTP = () => {
  state.loading = true;
  resetData();
  OTPService.resendOTP({
    request_type: props.requestType,
    mobile_number: props.mobile_number,
    email: state.email,
    model_id: '0',
  }).then(({ data: { result, status } }) => {
    if (status === 200) {
      toast.add({
        severity: ToastSeverity.SUCCESS,
        detail: result,
        life: 3000,
      });
      state.counter = 300;
    } else if (status === 202) state.counter = result;
    startCounter();
  }).finally(() => {
    state.loading = false;
  })
}

const formattedCounter = computed(() => {
  if (state.counter >= 60) {
    let minutes = Math.floor(state.counter / 60);
    let seconds = state.counter % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  } else {
    return `0:${state.counter < 10 ? '0' : ''}${state.counter}`;
  }
});

const otp = computed(() => {
  return `${state.num1}${state.num2}${state.num3}${state.num4}${state.num5}${state.num6}`;
});
const isDisabled = computed(() => {
  return state.counter > 0 || !state.email || v$.value.email.$invalid;
});
const isOTPFilled = computed(() => {
  return (
    state.num1 !== null &&
    state.num2 !== null &&
    state.num3 !== null &&
    state.num4 !== null &&
    state.num5 !== null &&
    state.num6 !== null
  );
});
</script>

<style lang="scss" scoped>
:deep(.digit) {
  padding: 0;
  margin: 0.4rem;
  height: clamp(36px, 9vw, 50px);
  width: clamp(36px, 9vw, 50px);
  font-size: clamp(0.9rem, 3.5vw, 1.1rem);
  border-radius: 5px;
  border-color: #d9d9d9;
  border-width: 1px;
  text-align: center;
}
.button-loading {
  border-radius: 2rem !important;
}

@media (max-width: 575px) {
  :deep(.digit) {
    margin: 0.25rem;
  }
}
</style>